import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createSquareNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawSquareBackground } from '../drawIconBackground';

const ICON_SIZE = 40;

function createAwsIgwIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const icon = `
    ${drawSquareBackground(ICON_SIZE, opts.style)}
    <path d="M19.9997 4.72729C28.4213 4.72729 35.2721 11.5775 35.2721 20C35.2719 28.4224 28.4212 35.2715 19.9997 35.2715C11.5771 35.2713 4.72747 28.4223 4.7273 20C4.7273 11.5776 11.577 4.72747 19.9997 4.72729Z" fill="white"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M26.0432 27.157H25.088V15.8854C25.088 15.6347 24.9407 15.4071 24.7124 15.3044L24.6537 15.2776C23.3726 14.6993 22.0469 14.1005 20.1416 14.1005C18.1501 14.1005 16.6886 14.7439 15.2436 15.4613C15.0268 15.5691 14.8897 15.7903 14.8897 16.0327V27.157H13.9568V15.1265C15.5089 13.8645 17.7465 13.1452 20.1479 13.1452C22.3804 13.1452 24.5089 13.781 26.0432 14.8976V27.157ZM20.1479 11.8699C17.3263 11.8699 14.6838 12.7747 12.897 14.3536C12.7599 14.4742 12.6815 14.6483 12.6815 14.8313V27.7947C12.6815 28.1474 12.9665 28.4324 13.3192 28.4324H15.5274C15.88 28.4324 16.1651 28.1474 16.1651 27.7947V16.4299C17.3888 15.8388 18.5748 15.3758 20.1416 15.3758C21.6305 15.3758 22.7133 15.8063 23.8126 16.2979V27.7947C23.8126 28.1474 24.0977 28.4324 24.4503 28.4324H26.6808C27.0335 28.4324 27.3185 28.1474 27.3185 27.7947V14.5819C27.3185 14.3881 27.2299 14.2044 27.0775 14.0826C25.3086 12.6765 22.7828 11.8699 20.1479 11.8699ZM20 32.7246C12.9844 32.7246 7.27534 27.0161 7.27534 19.9997C7.27534 12.9833 12.9844 7.27537 20 7.27537C27.0163 7.27537 32.7247 12.9833 32.7247 19.9997C32.7247 27.0161 27.0163 32.7246 20 32.7246ZM20 6C12.2804 6 6 12.2805 6 19.9997C6 27.7201 12.2804 34 20 34C27.7196 34 34 27.7201 34 19.9997C34 12.2805 27.7196 6 20 6Z" fill="#8C4FFF"/>
  `;

  return wrapNodeIconInSvgTag(icon, ICON_SIZE, ICON_SIZE, 'topLeft', opts);
}

export const awsIgwIcon: NodeTypeIcon = createSquareNodeTypeIcon(
  ICON_SIZE,
  createAwsIgwIcon,
);
